import { render, staticRenderFns } from "./pageTwelve.vue?vue&type=template&id=74daedce&scoped=true&"
import script from "./pageTwelve.vue?vue&type=script&lang=js&"
export * from "./pageTwelve.vue?vue&type=script&lang=js&"
import style0 from "./pageTwelve.vue?vue&type=style&index=0&id=74daedce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74daedce",
  null
  
)

export default component.exports